module.exports = __webpack_public_path__ + "img/chauffe-eau-electrique.51efddc9.svg";